<template>
    <div class="app home-page" :class="{ fda: isFdaFriendly }" :dir="direction">
        <app-header />
        <mobile-sub-header />

        <lab-sub-header-home-page />
        <demo-disclaimer v-if="showDemoDisclaimer" />

        <home-page-main-body
            :class="{ 'has-disclaimer': showDemoDisclaimer || fdaUnfriendlyDisclaimerIsShown }"
        />

        <disclaimer
            v-if="fdaUnfriendlyDisclaimerIsShown"
            class="fda-banner"
            @click.native.stop="hideFdaBanner"
        >
            <span>{{ $translate('fda_disclaimer_investigational') }}</span>
            <span>{{ $translate('fda_disclaimer_not_for_clinical_app') }}</span>

            <i class="fa fa-close close-banner-btn"></i>
        </disclaimer>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import UIUtils from '../../business/utils/UIUtils'

import AppHeader from '../components/Header'
import Disclaimer from '../components/partials/Disclaimer.vue'
import DemoDisclaimer from '../components/common/DemoDisclaimer.vue'
import LabSubHeaderHomePage from '../components/LabSubHeaderHomePage'
import MobileSubHeader from '../components/MobileSubHeader'
import HomePageMainBody from '../components/HomePageMainBody'

export default {
    name: 'HomePage',
    components: {
        MobileSubHeader,
        AppHeader,
        Disclaimer,
        DemoDisclaimer,
        LabSubHeaderHomePage,
        HomePageMainBody
    },
    data: () => ({
        refreshInterval: null
    }),
    computed: {
        ...mapState({
            user: state => state.common.user,
            patients: state => state.timelapse.patients,
            fdaUnfriendlyBannerWasShown: state => state.common.fdaUnfriendlyBannerWasShown
        }),
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly',
            fdaUnfriendlyDisclaimerIsShown: 'common/fdaUnfriendlyDisclaimerIsShown',
            direction: 'locale/direction',
            showDemoDisclaimer: 'common/showDemoDisclaimer'
        })
    },
    mounted() {
        this.loadInstrumentsData(false)

        this.refreshInterval = window.setInterval(() => {
            this.loadInstrumentsData(true)
        }, 300000)
    },
    beforeDestroy() {
        if (this.refreshInterval) {
            window.clearInterval(this.refreshInterval)
        }
        this.hideFdaBanner()
    },
    methods: {
        async loadInstrumentsData(isRefresh) {
            if (!isRefresh) {
                UIUtils.showLoadingMask()
                this.$log.navigationEvent('goto_home_page')
            }

            await this.$store.dispatch('timelapse/setPatients')

            if (this.patients.length > 0) {
                if (!isRefresh) UIUtils.showLoadingMask()

                const selectedTenant = this.user.tenants[0]

                this.$store.commit('common/setSelectedTenant', selectedTenant)
                await this.$store.dispatch('timelapse/setInstruments', selectedTenant._id)

                if (!isRefresh) UIUtils.hideLoadingMask()
            }
        },
        hideFdaBanner() {
            this.$store.commit('common/fdaUnfriendlyBannerWasShown', true)
        }
    }
}
</script>

<style lang="scss" scoped>
.home-page {
    position: relative;

    .mobile-sub-header {
        background-color: $dark-2;

        @media screen and #{$new-break2close}, #{$new-break4open} {
            display: none;
        }
    }

    .home-page-main-body {
        @media screen and #{$new-break2close}, #{$new-break4open} {
            // header + subheader
            height: calc(100% - #{$header-height} - #{$sub-header-height});

            &.has-disclaimer {
                // header + subheader + disclaimer
                height: calc(100% - #{$header-height} - 2 * #{$sub-header-height});
            }
        }

        @media screen and #{$new-break3} {
            // header + searchbar + subheader
            height: calc(100% - 2 * #{$header-height} - #{$sub-header-height});

            &.has-disclaimer {
                // header + searchbar + subheader + disclaimer
                height: calc(100% - 2 * #{$header-height} - 2 * #{$sub-header-height});
            }
        }
    }

    .fda-banner {
        padding-left: 2rem;

        .close-banner-btn {
            padding: 1rem;
            position: absolute;
            left: 0;
            cursor: pointer;
        }
    }
}
</style>
